import $ from 'jquery';
import Accordion from 'react-bootstrap/Accordion';
import SupplierMasterData from './SupplierMasterData';
import { useDispatch } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import { deleteSupplier, getSupplierSuccess, start } from '../../store/slices/TeamManagementSlice';
import CreateSupplier from './CreateSupplier';
import DeleteModal from '../Modals/DeleteModal';
import { useEffect, useState } from 'react';
import { remove } from '../../services/upload-files.service';
import ViewModal from '../Modals/ViewModal';
const SupplierMaster = () => {
    const [show, setShow] = useState(false);
    const [view, setView] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [currentVal, setCurrentVal] = useState(null)
    const [supplierId, setSupplierId] = useState(null)
    const dispatch = useDispatch();
    const { data } = useFetch('suppliers');

    useEffect(() => {
        if (data.results) {
            dispatch(getSupplierSuccess(data));
        } else (
            dispatch(start())
        )
    }, [data, dispatch])


    const handleDeleteResponse = (response) => {
        setShow(false);
        if (supplierId && response) {
            dispatch(start());
            remove(`suppliers?id=${supplierId}`).then((res) => {
                if (res.affectedRows > 0) {
                    dispatch(deleteSupplier(supplierId));
                }
            });
        }
    };

    const handleClose = () => {
        setView(false);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const body =
        <>
            <ul class="list-group list-group-vertical">
                <li class="list-group-item"><b>Supplier Name : </b>{currentVal?.name}</li>
                <li class="list-group-item"><b>Department : </b>{currentVal?.department_name}</li>


                <li class="list-group-item"><b>Supervisor : </b>{currentVal?.supervisor_name}</li>
                <li class="list-group-item"><b>Contact Person Name : </b>{currentVal?.contact_person_name}</li>
  

                <li class="list-group-item"><b>Email : </b>{currentVal?.email}</li>
                <li class="list-group-item"><b>Contact : </b>{currentVal?.contact}</li>


                <li class="list-group-item"><b>Address : </b>{currentVal?.address}</li>
                {/* <li class="list-group-item"><b>City : </b>{currentVal?.city}</li>
            
                <li class="list-group-item"><b>State : </b>{currentVal?.state}</li>
                <li class="list-group-item"><b>Zip : </b>{currentVal?.zip}</li>
          
            
                <li class="list-group-item"><b>Country : </b>{currentVal?.country}</li> */}
            </ul>

        </>

    return (
        <>
            <div className="row">
                <div className="col-sm-4 position-relative">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control"
                    />
                    <span className="fa fa-search department-search-icon"></span>
                </div>
                <div className="col-sm-8">
                    <CreateSupplier />
                </div>
            </div>
            {/* <div className='accordion-main'> */}
            <table className="table">
                <thead>
                    <tr>
                        <th onClick={() => handleSort('id')}>Supplier ID <i class="fa-solid fa-sort"></i></th>

                        <th onClick={() => handleSort('name')}>Supplier Name <i class="fa-solid fa-sort"></i></th>

                        <th onClick={() => handleSort('contact_person_name')}>Contact Person Name <i class="fa-solid fa-sort"></i></th>
                        {/* <th>Email</th> */}
                        {/* <th>Contact Number</th> */}
                        <th onClick={() => handleSort('supervisor_name')}>Supervisor <i class="fa-solid fa-sort"></i></th>

                        <th onClick={() => handleSort('department_name')}>Department <i class="fa-solid fa-sort"></i></th>
                        <th colSpan="3" style={{ textAlign: "center" }}>Actions</th>
                        {/* <th>Address</th> */}
                    </tr>
                </thead>
                <tbody>
                    <SupplierMasterData setSupplierId={setSupplierId} setShow={setShow} setView={setView} setCurrentVal={setCurrentVal} searchTerm={searchTerm} sortConfig={sortConfig} />
                </tbody>
            </table>
            <DeleteModal handleDeleteResponse={handleDeleteResponse} show={show} title={"Supplier"} />
            <ViewModal handleClose={handleClose} body={body} view={view} title={"Supplier Info"} />
            {/* </div> */}
            {/* <div className='accordion-main'>
                <Accordion defaultActiveKey="0">
                    <div className='fixedheader'>
                        <span><b>Supplier ID</b></span>
                        <span><b>Supplier Name</b></span>
                        <span><b>Contact Person Name</b></span>
                        <span><b>Email</b></span>
                        <span><b>Contact Number</b></span>
                    </div>
                    <SupplierMasterData />
                </Accordion>
            </div> */}
        </>
    );
}

export default SupplierMaster;